import * as React from "react";
import styled from "styled-components";

const Title = styled.h4`
  font-size: 18px;
  color: #999;
`;
export default Title;
